import React from "react";
import { Check, ChevronRight } from "lucide-react";
import { TIER_VISUALS } from "./VipMembershipCard";

const ORDERED = ["none", "bronze", "silver", "gold", "platinum", "diamond"];

export const VipTimeline = ({ currentTier = "none", tiers = [] }) => {
    const currentIdx = Math.max(0, ORDERED.indexOf(currentTier));
    const tierMap = Object.fromEntries(tiers.map((t) => [t.slug, t]));

    return (
        <div className="glass-elevated rounded-2xl p-5 sm:p-6" data-testid="vip-timeline">
            <p className="text-[10px] font-mono uppercase tracking-[0.3em] text-[var(--text-muted)] mb-4">
                Membership progression
            </p>
            <div className="grid grid-cols-3 sm:grid-cols-6 gap-2 sm:gap-3">
                {ORDERED.map((slug, idx) => {
                    const v = TIER_VISUALS[slug];
                    const Icon = v.Icon;
                    const meta = tierMap[slug] || {};
                    const unlocked = idx <= currentIdx;
                    const isCurrent = idx === currentIdx;
                    return (
                        <div
                            key={slug}
                            className={`relative flex flex-col items-center text-center p-3 rounded-xl border transition-all duration-500 ${
                                isCurrent
                                    ? "vip-timeline-current scale-105"
                                    : unlocked
                                        ? "border-white/15 bg-white/[0.02]"
                                        : "border-white/5 bg-black/30 opacity-50"
                            }`}
                            style={
                                isCurrent
                                    ? {
                                          borderColor: v.border,
                                          boxShadow: `0 0 24px ${v.accentSoft}, inset 0 0 16px ${v.accentSoft}`,
                                          background: `linear-gradient(135deg, ${v.accentSoft}, transparent)`,
                                      }
                                    : undefined
                            }
                            data-testid={`vip-timeline-${slug}`}
                        >
                            <div
                                className="w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center mb-2"
                                style={{
                                    background: unlocked ? `radial-gradient(circle, ${v.accentSoft}, transparent 70%)` : "rgba(255,255,255,0.03)",
                                    border: `1px solid ${unlocked ? v.border : "rgba(255,255,255,0.08)"}`,
                                }}
                            >
                                <Icon size={20} style={{ color: unlocked ? v.accent : "rgba(255,255,255,0.3)" }} />
                            </div>
                            <p className="text-[10px] sm:text-xs font-display font-bold uppercase tracking-wider"
                                style={{ color: unlocked ? v.accent : "rgba(255,255,255,0.4)" }}>
                                {v.label}
                            </p>
                            <p className="text-[9px] font-mono text-[var(--text-muted)] mt-0.5">
                                {meta.threshold > 0 ? `A$${meta.threshold}+` : "Start"}
                            </p>
                            <p className="text-[9px] font-mono text-white/60 mt-0.5">
                                {meta.discount_pct || 0}% off
                            </p>
                            {unlocked && !isCurrent && (
                                <div className="absolute top-1.5 right-1.5 w-4 h-4 rounded-full bg-emerald-500/80 flex items-center justify-center">
                                    <Check size={10} className="text-white" strokeWidth={3} />
                                </div>
                            )}
                            {isCurrent && (
                                <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 px-1.5 py-0.5 rounded-full text-[8px] font-mono uppercase tracking-widest bg-black/70"
                                    style={{ color: v.accent, border: `1px solid ${v.border}` }}>
                                    Current
                                </div>
                            )}
                            {idx < ORDERED.length - 1 && (
                                <ChevronRight size={10} className="hidden sm:block absolute -right-2.5 top-1/2 -translate-y-1/2 text-white/20" />
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
